import { Card, Chip } from '@material-tailwind/react';
import React, { useState, useEffect } from 'react'
import APopover from '../../../components/partials/APopover';
import EmptyTable from '../../../components/table/EmptyTable';
import Pagination from '../../../components/table/Pagination';
import { useShared } from '../../../hooks/useShared';
import { data } from '../../dashboard/parials/BarChart';


const Tariff_TABLE_HEAD = ["#", "شماره", "نام/ شرکت", 'اجناس', 'حالت تعرفه', 'تاریخ'];

export default function UserTariffTable({ v }) {
    const { http, com, roles, photo, setPhoto, setModel, model, uploadPhoto, location, consts, setShowFilesModal } = useShared();
    const [loading, setLoading] = useState(false)
    const [tariffs, setTariffs] = useState([])



    const getTariffs = (page = 1, data) => {
        if (v.company_id > 0) {


            setLoading(true)
            http.post(`api/tariffsAdvanceSearch?page=${page}`, data).then(res => {
                console.log('ViewUser getTariffs data ', res);
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                    setTariffs(data)

                }
                setLoading(false)

            }, err => {
                console.log('err');
                setLoading(false)
            })
        }
    }
    useEffect(() => {
        getTariffs(1, { company_id: v.company_id })
    }, [])


    const getTariffTableData = () => {

        return (<tbody className=''>
            {tariffs?.data?.map((r, i) => {
                return (<tr key={r.id}>
                    <td >{tariffs.from + i}</td>
                    <th>{r?.id}</th>
                    <th>{r?.company ? r?.company?.name_af : r?.name}</th>

                    <td >
                        {r?.items?.map((item, j) => {
                            return (<span key={j} className='ml-1'>{item?.category?.label}{j < r?.items?.length - 1 && <span >،</span>} </span>)
                        })}
                        <p>{com.NumberFormatter(r?.amount)} ؋</p>
                        <APopover v={{ data: itemsPopup(r?.items), className: "mt-3 ", btn: '!bg-deep-purple-900/20 ', iconCss: '!text-deep-purple-500' }} />
                    </td>

                    <td>

                        {r.aviza_date && <span>  {com.dateConvert(r?.aviza_date, false)}</span>}
                        <Chip className='capitalize text-center px-1' variant="ghost" size="sm" color={r.status === 0 && r.attachments?.length === 0 ? 'gray'
                            : r.status === 1 ? 'orange'
                                : r.status === 2 ? 'green' : 'red'}
                            value={r.status === 0 ? 'Upload Aviza'
                                : r.status === 1 ? 'Pending Aproval'
                                    : r.status === 2 ? 'Completed'
                                        : 'Rejected'} />
                    </td>

                    <td >
                        {com.dateConvert(r?.created_at, false, true)}
                        <p>{r?.user?.full_name}</p>
                    </td>
                </tr>
                )
            })}
        </tbody>)
    }

    const itemsPopup = (items) => <table style={{ direction: 'rtl' }} className=" gTable  ">
        <thead>
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>نام جنس</th>
                <th> مقدار پول</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.tariff_amount} ؋</td>

                </tr>
            ))}
        </tbody>
    </table>

    return (
        <div>
            <Card className="p-2 md:p-4 mt-4 relative">
                <div className='text-main-color font-bold border-b mb-2'>تعرفه‌ها</div>
                <div className={`overflow-auto grid grid-cols-1 content-between`}>
                    <table className="gTable">
                        <thead className='whitespace-nowrap'>
                            <tr className='!bg-teal-500'>
                                {Tariff_TABLE_HEAD?.map((head, i) => (
                                    <th key={head} className={`${head === "Description" && 'w-[20%]'} px-2`}> {head}</th>
                                ))}
                            </tr>
                        </thead>
                        {getTariffTableData()}
                    </table>
                    <EmptyTable value={{ loading: loading, length: tariffs?.data?.length }} />
                    {tariffs && <Pagination value={{ getFun: getTariffs, data: tariffs }} />}
                </div>
            </Card>
        </div>
    )
}
